exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".functional-logo-container[data-v-0dbc90ea]{width:210px;height:60px;line-height:60px;background:#fff;text-align:center;overflow:hidden;-ms-flex-negative:0;flex-shrink:0}.functional-logo-container .sidebar-logo-link[data-v-0dbc90ea]{height:100%;width:100%}.functional-logo-container .sidebar-logo-link .sidebar-logo[data-v-0dbc90ea]{height:100%;width:100%}", ""]);

// exports
